import React from 'react';
import styles from './AdminUserDetailProjects.module.scss';
import { Skeleton } from '@tcc-online/common-components';
import { useTranslate } from 'react-translate.ts';
import AdminProjectDetailCard from '../../../../project/AdminProjectDetailCard/AdminProjectDetailCard';
import { generatePath, Link } from 'react-router-dom';
import AdminButton from '../../../../buttons/AdminButton/AdminButton';
import AdminUserProject from '../../../../../types/users/AdminUserProject';
import AdminTable, {
    AdminTableHeadRow,
    AdminTableRow,
} from '../../../../AdminTable/AdminTable';
import getProductNameFromType from '../../../../../helpers/getProductNameFromType';
import {
    ADMIN_DASHBOARD_PATH,
    ADMIN_PATH,
    ADMIN_PRODUCT_PATH,
    ADMIN_PROJECT_DETAIL_PATH,
} from '../../../../../../constants/route.constants';

interface AdminUserDetailProjectsProps {
    projects: AdminUserProject[];
    title: string;
    link?: string;
    loading?: boolean;
}

const skeletons = Array.from(new Array(5), (_, index) => (
    <Skeleton key={index} className={styles.skeleton} />
));

export default function AdminUserDetailProjects(
    props: AdminUserDetailProjectsProps,
) {
    const { title, projects, loading, link } = props;
    const translate = useTranslate();

    return (
        <AdminProjectDetailCard title={title}>
            {!loading ? <Table projects={projects} /> : skeletons}
            {link && (
                <Link to={link} className={styles.link}>
                    <AdminButton>{translate('Prejit na projekty')}</AdminButton>
                </Link>
            )}
        </AdminProjectDetailCard>
    );
}

function Table(props: { projects: AdminUserProject[] }) {
    const { projects } = props;
    const translate = useTranslate();
    return (
        <AdminTable>
            <AdminTableHeadRow className={styles.row}>
                <div>{translate('Název')}</div>
                <div>{translate('Typ')}</div>
            </AdminTableHeadRow>
            {projects?.map((project: AdminUserProject) => (
                <AdminTableRow key={project.projectId} className={styles.row}>
                    <Link
                        to={generatePath(
                            `${ADMIN_PATH}/${ADMIN_DASHBOARD_PATH}/${ADMIN_PRODUCT_PATH}/${ADMIN_PROJECT_DETAIL_PATH}`,
                            {
                                productId: project.type.toString(),
                                projectId: project.projectId.toString(),
                            },
                        )}
                        relative="path"
                    >
                        <div>{project.name}</div>
                    </Link>
                    <div>{translate(getProductNameFromType(project.type))}</div>
                </AdminTableRow>
            ))}
        </AdminTable>
    );
}
